import React from 'react';
import { Link } from 'react-router-dom';
import './LandingFooter.css';

export default function LandingFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="landing-footer">
      <div className="landing-footer__inner">
        <div className="landing-footer__brand">
          <div className="landing-footer__lockup display">
            Bella <em>7</em>
          </div>
          <p className="landing-footer__tag">
            A quiet salon for haircuts, color, and bridal moments.
          </p>
        </div>

        <div className="landing-footer__cols">
          <div>
            <div className="landing-footer__col-label mono">Visit</div>
            <p>106 Kays Ave, Trussville, AL</p>
            <p>Mon–Fri · 9–4</p>
          </div>

          <div>
            <div className="landing-footer__col-label mono">Quick links</div>
            <a href="#book">Book a chair</a>
            <a href="#contact">Contact</a>
          </div>

          <div>
            <div className="landing-footer__col-label mono">Fine print</div>
            <Link to="/privacypolicy">Privacy</Link>
            <Link to="/termsandconditions">Terms</Link>
          </div>
        </div>
      </div>

      <div className="landing-footer__base">
        <span className="mono">© {year} Bella 7</span>
        <span className="mono">Made with care</span>
      </div>
    </footer>
  );
}